import React from 'react';
import { LoanPipeline } from './pages/LoanPipeline';
export function App() {
  return <LoanPipeline data-id="element-0" />;
}